import { render, staticRenderFns } from "./PricingRules.vue?vue&type=template&id=025b4d56&scoped=true&"
import script from "./PricingRules.vue?vue&type=script&lang=ts&"
export * from "./PricingRules.vue?vue&type=script&lang=ts&"
import style0 from "./PricingRules.vue?vue&type=style&index=0&id=025b4d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b4d56",
  null
  
)

export default component.exports